import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ShirtIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8.5 3 12 5.2 15.5 3 21 6.2l-2.4 3.6L17 9v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9l-1.6.8L3 6.2z" />
  </svg>
)
